import { io } from "socket.io-client";
import * as util from "services/util";

let socket = null;

/**
 * Initializes a secure Socket.IO connection using JWT authentication.
 *
 * - JWT is included in the socket handshake via `auth.token`.
 * - Backend extracts memberId from token to build a onlineMembers map.
 * - onMessage() handles push_notification events.
 */

export function initSocketConnection(onMessage) {
  if (socket) return socket; // Prevent double connect

  let base = null;
  try {
    base = util.apiDomainUrl("")?.replace(/\/?$/, "");
  } catch (e) {
    console.error("Error getting base API domain:", e);
  }

  // Production FIX: to override localhost URL
  if (
    window.location.hostname !== "localhost" &&
    (base.includes("localhost") || base.includes("127.0.0.1"))
  ) {
    base = window.location.origin; 
  }

  const SOCKET_SERVER_URL = base;

  // ---------------- JWT GET ----------------
  const token = util.getAuth();
  if (!token) {
    console.warn("Socket connection blocked: No JWT token found");
    return;
  }

  // ---------------- CONNECT ----------------
  socket = io(SOCKET_SERVER_URL, {
    transports: ["websocket"],
    withCredentials: true,
    path: "/socket.io",
    auth: {
      token: token, // <--- JWT sent fot handshake
    },
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
  });

  // ---------------- LOGS ----------------
  socket.on("connect", () => {
    console.log("Connected to socket server");
  });

  socket.on("connect_error", (err) => {
    console.error("Socket connection error:", err?.message || err);
  });

  socket.on("disconnect", (reason) => {
    console.warn("Socket disconnected:", reason);
  });

  // ---------------- CORE NOTIFICATION LISTENER ----------------
  socket.on("push_notification", (msg) => {
    console.log("Received notification:", msg);
    if (onMessage) onMessage(msg);
  });

  window.socket = socket; // Debug convenience

  return socket;
}

export function getSocket() {
  return socket;
}

/**
 * Close and clean up the socket connection
 */
export function closeSocket() {
  if (socket) {
    console.log("Closing socket connection");
    socket.disconnect();
    socket = null;
  }
}

export function refreshSocketAuth() {
  if (!socket) return;

  const newToken = util.getAuth();
  console.log("Refreshing socket auth…");

  socket.auth = { token: newToken };
  socket.disconnect().connect();
}
